const dinamicLinks = {
    wrap: document.getElementById('dinamicLink') as HTMLElement,
    section: document.querySelectorAll('.jsDinamicLink') as NodeListOf<HTMLElement>,

    init() {
        if(this.wrap) {
            this.setLinks();
        }

    },

    setLinks() {
        let html = '';
        this.section.forEach(item => {
            const title = item.dataset.title as string;
            const link = title.split(' ')[0] as string;
            item.id = link;
            html += this.createLinks(link, title);
        });
        this.wrap.innerHTML = html;
    },
    createLinks(link: string, title: string) {
        return `<li><a class="training-nav__link" href="#${link}">${title}</a> </li>`;
    }
}

export default dinamicLinks;